export type BoardTouchTap = {
  clientX: number;
  clientY: number;
};

const BOARD_TOUCH_TAP_MOVE_THRESHOLD_PX = 10;

export type BoardTouchTapTracking = {
  hadPinch: boolean;
  tapStartX: number;
  tapStartY: number;
  tapMoved: boolean;
};

export function shouldCommitBoardTouchTap({
  hadPinch,
  tapMoved,
}: Pick<BoardTouchTapTracking, "hadPinch" | "tapMoved">): boolean {
  return !hadPinch && !tapMoved;
}

export function initBoardTouchTapTracking(state: BoardTouchTapTracking, touch: Touch): void {
  state.tapStartX = touch.clientX;
  state.tapStartY = touch.clientY;
  state.tapMoved = false;
  state.hadPinch = false;
}

export function markBoardTouchTapMoved(state: BoardTouchTapTracking, touch: Touch): void {
  if (state.tapMoved) return;
  const dx = touch.clientX - state.tapStartX;
  const dy = touch.clientY - state.tapStartY;
  if (Math.hypot(dx, dy) > BOARD_TOUCH_TAP_MOVE_THRESHOLD_PX) {
    state.tapMoved = true;
  }
}

export function resetBoardTouchTapTracking(state: BoardTouchTapTracking): void {
  state.hadPinch = false;
  state.tapMoved = false;
}

export function commitBoardTouchTap({
  state,
  event,
  onTap,
}: {
  state: BoardTouchTapTracking;
  event: TouchEvent;
  onTap?: (tap: BoardTouchTap) => void;
}): void {
  if (!onTap || !shouldCommitBoardTouchTap(state)) return;
  const touch = event.changedTouches[0];
  if (!touch) return;
  onTap({ clientX: touch.clientX, clientY: touch.clientY });
}
